import { createSelector } from '@reduxjs/toolkit'
import { MedChronReference } from './schemas'
import { RootState } from '@/store/store'
import { MedChronReferencesRecord } from './slice'

/**
 * Select: Med Chron References by Store Key
 *
 * Returns the record of medical chronology references for the given store key, or null if it does not exist.
 */
export const selectMedChronReferencesByStoreKey = createSelector(
  [(state: RootState) => state.medChronReferencesState.references, (_: RootState, props: { storeKey: string | undefined | null }) => props.storeKey],
  (references, storeKey): MedChronReferencesRecord | null => {
    if (!storeKey) return null
    return references[storeKey] ?? null
  }
)

/**
 * Select: Med Chron Reference by ID
 *
 * Returns the medical chronology reference with the given id, or null if it does not exist.
 */
export const selectMedChronReferenceById = createSelector(
  [selectMedChronReferencesByStoreKey, (_: RootState, props: { storeKey: string | undefined | null; referenceId: string }) => props.referenceId],
  (references, referenceId): MedChronReference | null => {
    if (!references || !referenceId) return null
    return references[referenceId] ?? null
  }
)
